import { useUserStore } from '@/store/user';
import axios from 'axios';
/**
 * 替换query中的指定值
 * @param query query
 * @param key query中的键
 * @param val 要替换的值，默认为空
 */
export const replaceQuery = (query, key, val = '') => {
  const reg = new RegExp(`(\\?|&)${key}=(.*)`);
  return query.replace(reg, val);
};

/**
 * 获取文件后缀名
 * @param fileName 文件名
 */
export const getFileExtension = fileName =>
  fileName.substring(fileName.lastIndexOf('.') + 1);

/**
 * 从文件路径中获取文件名称
 * @param path 文件路径
 */
export const getFileNameFromPath = filePath =>
  filePath.replace(/(.*\/)*([^.]+).*/gi, '$2');

/**
 * 模拟延时
 * @param delay 延时
 */
export const sleep = (delay = 1000) =>
  new Promise(resolve => {
    setTimeout(() => {
      resolve();
    }, delay);
  });

/**
 * 判断是否有权限
 */
export const hasBtnPermission = roles => {
  const userStore = useUserStore();
  return roles.some(role => userStore.roles.includes(role));
};

/**
 * 将文件 url 格式转换为 Bolb 类型格式 或者 arraybuffer 格式
 */
export const getFile = url =>
  new Promise((resolve, reject) => {
    axios({
      method: 'get',
      url,
      responseType: 'blob'
    })
      .then(data => {
        resolve(data.data);
      })
      .catch(error => {
        reject(error.toString());
      });
  });

/**
 * 获取到的文件后缀，转成icon-class对应的值
 */
export const getExtensionToIcon = (extension, item) => {
  const str = extension ? extension.toLowerCase() : '';
  if (item.fileType === 0) {
    return item?.isLink ? 'fileShortcut' : 'file';
  }
  if (str === '.pdf') {
    return item?.isLink ? 'pdfShortcut' : 'pdf';
  }
  if (
    str === '.bmp' ||
    str === '.jpg' ||
    str === '.png' ||
    str === '.gif' ||
    str === '.psd' ||
    str === '.svg' ||
    str === '.wmf' ||
    str === '.tga' ||
    str === '.jpeg' ||
    str === '.tiff'
  ) {
    return item?.isLink ? 'pictureShortcut' : 'picture';
  }
  if (str === '.txt') {
    return item?.isLink ? 'txtShortcut' : 'txt';
  }
  if (
    str === '.wmv' ||
    str === '.asf' ||
    str === '.asx' ||
    str === '.rm' ||
    str === '.rmvb' ||
    str === '.mp4' ||
    str === '.3gp' ||
    str === '.mov' ||
    str === '.m4v' ||
    str === '.avi' ||
    str === '.dat' ||
    str === '.mkv' ||
    str === '.flv' ||
    str === '.vob'
  ) {
    return item?.isLink ? 'videoShortcut' : 'video';
  }
  if (str === '.ppt' || str === '.pptx') {
    return item?.isLink ? 'pptShortcut' : 'ppt';
  }
  if (str === '.doc' || str === '.docx') {
    return item?.isLink ? 'wordShortcut' : 'word';
  }
  if (str === '.xlsx' || str === '.xls' || str === '.xlsm') {
    return item?.isLink ? 'xlsxShortcut' : 'xlsx';
  }
  if (
    str === '.zip' ||
    str === '.rar' ||
    str === '.tar' ||
    str === '.bz2' ||
    str === '.gz' ||
    str === '.7z' ||
    str === '.xz'
  ) {
    return item?.isLink ? 'zipShortcut' : 'zip';
  }
  if (
    str === '.wma' ||
    str === '.mp3' ||
    str === '.wav' ||
    str === '.aac' ||
    str === '.ogg' ||
    str === '.m4a' ||
    str === '.ape' ||
    str === '.flac'
  ) {
    return item?.isLink ? 'audioShortcut' : 'audio';
  }
  return item?.isLink ? 'unknownShortcut' : 'unknown';
};
